import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { useShop } from '../context/ShopContext';
import { FaSpinner } from 'react-icons/fa';
import EmptyState from "./EmptyState";
const Commission = () => {

    const [products, setProducts] = useState([]);
    const [amounts, setAmounts] = useState({});
    const [loading, setLoading] = useState(true);
    const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
    const inputRefs = useRef([]);
    const { shopId , companyId} = useShop();
    const [partyMasters, setPartyMasters] = useState([]);
    const [selectedParty, setSelectedParty] = useState("");
    const [selectedPartyId, setSelectedPartyId] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
   




  const showToast = (message, type = "error") => {
                toast.dismiss(); 
              
                console.log("Toast Type:", type); 
              
                if (type.toLowerCase() === "error") {
                  toast.error(message);
                } else if (type.toLowerCase() === "success") {
                  toast.success(message);
                } else {
                  console.warn("Invalid toast type:", type);
                }
              };








    const fetchProducts = async () => {
        try {
            setLoading(true);
            console.log("Fetching products for:", { shopId, date });
    
            // Validate date before conversion
            const formattedDate = date ? new Date(date).toISOString() : null;
            if (!formattedDate) {
                throw new Error("Invalid date provided.");
            }
    
            const response = await axios.post(
                "https://winenew.sipstocks.in/api/Liquor/GetTodaySalesProduct",
                {
                    shopId: shopId,
                    typeId: "1",
                    stockDate: date || new Date().toISOString().split("T")[0], // Ensure valid date format
                },
                {
                    headers: {
                        "accept": "*/*",
                        "Content-Type": "application/json",
                    }
                }
            );
    
            console.log("API Response Comission:", response);
    
            if (response.data?.code === 200 && Array.isArray(response.data.data)) {
                const formattedProducts = response.data.data.map(product => ({
                    id: product.id,
                    pName: product.pName,
                    packing: product.packing,
                    mrp: parseFloat(product.mrp) || 0,
                    totalSale: Math.round(parseFloat(product.salesToday) || 0),
                }));
    
                setProducts(formattedProducts);
    
                // Initialize amounts with commissionSale as empty and counterSale from totalSale
                const initialAmounts = formattedProducts.reduce((acc, product) => {
                    acc[product.id] = {
                        commissionSale: "",
                        counterSale: product.totalSale,
                    };
                    return acc;
                }, {});
    
                setAmounts(initialAmounts);
            } else {
                showToast(response.data?.message || "Failed to fetch products","error");
                setProducts([]);
            }
        } catch (error) {
            console.error("API Error:", error);
            showToast(error.response?.data?.message || "Error fetching products","error");
            setProducts([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProducts();
    }, [date]);




    const handleInputChange = (id, field, value) => {
          let product = products.find(p => p.id === id);
    
        setAmounts(prev => {
            let updatedAmount = { ...prev[id] };
    
            if (field === "commissionSale") {
                let commissionSale = value ? parseFloat(value) : 0;
                let totalSale = product.totalSale;
                let counterSale = totalSale - commissionSale;
    
                if (commissionSale < 0) {
                    showToast('Commission Sale cannot be negative', "error");
                    return prev;
                }
    
                if (commissionSale > totalSale) {
                    showToast('Commission Sale cannot be greater than Total Sale', "error");
                    return prev;
                }
    
                updatedAmount.commissionSale = commissionSale;
                updatedAmount.counterSale = counterSale;
            } 
            else if (field === "commissionValue") {
                let commissionValue = value ? parseFloat(value) : ""; 
                let commissionSale = prev[id]?.commissionSale || 0;
                let maxCommissionValue = commissionSale * product.mrp;
    
                if (commissionValue < 0) {
                    showToast('Commission Value cannot be negative', "error");
                    updatedAmount.commissionValue = ""; 
                    updatedAmount.commissionPercent = ""; // reset percent
                    return { ...prev, [id]: updatedAmount };
                }
    
                if (commissionValue > maxCommissionValue) {
                    showToast(`Commission Value cannot exceed ${maxCommissionValue}`, "error");
                    updatedAmount.commissionValue = ""; 
                    updatedAmount.commissionPercent = ""; // reset percent
                    return { ...prev, [id]: updatedAmount };
                }
    
                updatedAmount.commissionValue = commissionValue; 
    
              
                // Updated commission percent calculation
                   if (commissionSale > 0 && product.mrp > 0) {

                   console.log("commissionValue",commissionValue)
                    console.log("commissionSale * product.mrp",commissionSale * product.mrp)
                    updatedAmount.commissionPercent = ((commissionValue / (commissionSale * product.mrp)) * 100).toFixed(2);

                     console.log("update amount:",updatedAmount.commissionPercent)
    } else {
                    updatedAmount.commissionPercent = "0.00";
                }
            } 
            else if (field === "remark") {
                updatedAmount.remark = value; 
            }
    
            return { ...prev, [id]: updatedAmount };
        });
    };
    
    
    
 const handleSubmit = async () => {
     
        if (!selectedPartyId) {
            showToast("Please select a party before submitting!", "error");
            return; // stop submission
        }
    
        try {
            setLoading(true);
    
            const dataToSubmit = products
                .map((product, index) => {
                    const commissionSale = parseFloat(amounts[product.id]?.commissionSale) || 0;
                    const commissionValue = parseFloat(amounts[product.id]?.commissionValue) || 0;
                    const remark = amounts[product.id]?.remark || "";
                    const rate = product.mrp; 
    
                    if (commissionSale === 0 && commissionValue === 0) {
                        return null; 
                    }
    
                    const totalSale = product.totalSale;
                    const counterSale = totalSale - commissionSale;
    
                    // Calculate ProductPerCommission (percentage)
                    let productPerCommission = 0;
                    if (rate > 0) {
                        productPerCommission = ((commissionValue / (commissionSale * product.mrp)) * 100).toFixed(2);
                    }
    
                    return {
                        Id: index + 1,
                        ProductId: product.id,
                        ShopId: shopId,
                        rate: parseFloat(rate.toFixed(2)), 
                        CommissionSale: parseFloat(commissionSale.toFixed(2)),
                        CounterSale: parseFloat(counterSale.toFixed(2)),
                        TotalSale: totalSale,
                        CommissionValue: parseFloat(commissionValue.toFixed(2)),
                        SaleDate: date || new Date().toISOString().split("T")[0], // Ensure valid date format
                        RectimeStamp: date || new Date().toISOString().split("T")[0], // Ensure valid date format
                        Remark: remark,
                        CommissionId: selectedPartyId,
                        ProductPerCommission: productPerCommission,
                    };
                })
                .filter(item => item !== null);
    
            console.log("📊 Payload JSON:", JSON.stringify(dataToSubmit, null, 2));
    
            if (dataToSubmit.length === 0) {
                showToast("No valid data to submit!", "error");
                setLoading(false);
                return;
            }
    
            const response = await axios.post(
                "https://winenew.sipstocks.in/api/Liquor/SaveCommissionData",
                dataToSubmit,
                {
                    headers: {
                        "accept": "*/*",
                        "Content-Type": "application/json",
                    }
                }
            );
    
            if (response.data.code === 200) {
                showToast("Data submitted successfully!", "success");
                setTimeout(() => window.location.reload(), 2000);
                setAmounts({});
            } else {
                showToast("Failed to submit data", "error");
            }
        } catch (error) {
            showToast("Error submitting data", "error");
            console.error("API Error:", error);
        } finally {
            setLoading(false);
        }
    };
    
    
    
    

    
    

    const isSubmitEnabled = Object.values(amounts).some(amount => parseFloat(amount?.commissionSale) > 0);
    const totalCommissionValue = Object.values(amounts).reduce((sum, item) => {
        const value = parseFloat(item?.commissionValue) || 0;
        return sum + value;
      }, 0);


      const totalSale = products.reduce((sum, product) => sum + product.totalSale, 0);

       const totalCommissionSaleRate = products.reduce((sum, product) => {
       const commissionSale = amounts[product.id]?.commissionSale || 0;
       return sum + (commissionSale * product.mrp);
        }, 0);
      

       const Netsale = totalCommissionSaleRate-totalCommissionValue



    const netPercentage = totalCommissionSaleRate > 0 
              ? ((totalCommissionValue / totalCommissionSaleRate) * 100).toFixed(2) 
                  : "0.00";


    useEffect(() => {
        console.log("comapny id comission:",companyId)
        const fetchPartyMasters = async () => {
          try {
            const response = await axios.post(
              'https://winenew.sipstocks.in/api/Liquor/GetCommissionHead',
              { companyId },
              { headers: { accept: '*/*' } }
            );
            console.log("fetchPartyMasterscomission", response);
      
            const options = response.data?.data?.map((item) => ({
              id: item.id,
              label: item.name,
            }));
            setPartyMasters(options);
          } catch (err) {
            console.error('Error fetching party master options:', err);
            showToast('Failed to load Comission Head.',"error");
          }
        };
      
        fetchPartyMasters();
      }, []);






    return (
      <div className="p-4">
        <ToastContainer />

        {/* ── Filters ── */}
        <div className="form-group d-flex gap-5 mb-4 flex-wrap">
          <div className="col-lg-3 col-6">
            <label className="form-label">Date:</label>
            <input
              type="date"
              className="form-control"
              value={date}
              max={new Date().toISOString().split("T")[0]}
              onChange={(e) => setDate(e.target.value)}
            />
          </div>
          <div className="col-lg-3 col-6">
            <label className="form-label">Commission Head</label>
            <select
              className="form-control"
              value={selectedPartyId}
              onChange={(e) => setSelectedPartyId(e.target.value)}
            >
              <option value="">Select Head</option>
              {partyMasters.map((party) => (
                <option key={party.id} value={party.id}>{party.label}</option>
              ))}
            </select>
          </div>
          <div className="col-lg-3 col-6">
            <label className="form-label">Search Product</label>
            <input
              type="text"
              className="form-control"
              placeholder="Search product"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>

        {/* ── Table ── */}
        <div className="table-responsive h-700px">
          {loading ? (
            <div className="loader-container">
              <FaSpinner className="spinner-icon" />
            </div>
          ) : products.length > 0 ? (
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Product Name</th>
                  <th>Rate</th>
                  <th>Variant</th>
                  <th>Total Sale</th>
                  <th>Commission Sale</th>
                  <th>Counter Sale</th>
                  <th>Commission Value</th>
                  <th>Commission %</th>
                  <th>Remark</th>
                </tr>
              </thead>
              <tbody>
                {products
                  .filter((p) => p.pName.toLowerCase().includes(searchQuery.toLowerCase()))
                  .map((product, index) => (
                    <tr key={product.id}>
                      <td>{index + 1}</td>
                      <td>{product.pName}</td>
                      <td>{product.mrp}</td>
                      <td>{product.packing}</td>
                      <td>{product.totalSale}</td>
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          value={amounts[product.id]?.commissionSale || ""}
                          onChange={(e) => handleInputChange(product.id, "commissionSale", e.target.value)}
                        />
                      </td>
                      <td>{amounts[product.id]?.commissionSale ? amounts[product.id]?.counterSale : ""}</td>
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          value={amounts[product.id]?.commissionValue ?? ""}
                          onChange={(e) => handleInputChange(product.id, "commissionValue", e.target.value)}
                        />
                      </td>
                      <td>{amounts[product.id]?.commissionPercent}</td>
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          value={amounts[product.id]?.remark || ""}
                          onChange={(e) => handleInputChange(product.id, "remark", e.target.value)}
                        />
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          ) : (
            <EmptyState />
          )}
        </div>

        {/* ── Summary + Submit bar ── */}
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "space-between",
          flexWrap: "wrap", gap: 12, marginTop: 16,
          padding: "14px 18px",
          background: "linear-gradient(135deg, #0f172a 0%, #1e2a45 100%)",
          borderRadius: 12,
          boxShadow: "0 4px 16px rgba(99,102,241,0.15)",
        }}>
          <div style={{ display: "flex", gap: 20, flexWrap: "wrap", alignItems: "center" }}>
            {[
              { label: "Commission Value", value: `₹${totalCommissionValue.toFixed(2)}`, color: "#6366F1" },
              { label: "Sale Amount", value: `₹${totalCommissionSaleRate.toFixed(2)}`, color: "#10B981" },
              { label: "Net Sale", value: `₹${Netsale.toFixed(2)}`, color: Netsale >= 0 ? "#10B981" : "#EF4444" },
              { label: "Net %", value: `${netPercentage}%`, color: "#F59E0B" },
            ].map((item, i, arr) => (
              <React.Fragment key={item.label}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <div style={{ width: 8, height: 8, borderRadius: "50%", background: item.color, flexShrink: 0 }} />
                  <span style={{ fontSize: 11, color: "rgba(255,255,255,0.5)", fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5 }}>{item.label}</span>
                  <span style={{ fontSize: 14, fontWeight: 800, color: item.color }}>{item.value}</span>
                </div>
                {i < arr.length - 1 && <div style={{ width: 1, height: 24, background: "rgba(255,255,255,0.1)" }} />}
              </React.Fragment>
            ))}
          </div>
          <button
            className="btn btn-primary"
            onClick={handleSubmit}
            disabled={!isSubmitEnabled || loading}
            style={{ minWidth: 110, fontWeight: 700 }}
          >
            {loading ? "Submitting…" : "✓ Submit"}
          </button>
        </div>
      </div>
    )
};

export default Commission;
